import React, { useState } from "react";
import { AppstoreAddOutlined } from "@ant-design/icons";
import { Row, Col, Card, Button } from "antd";
import { PageHeaderLayout } from "../../../shared/layout";
import "./../library/creativestyle.css";
import AssignedAdGroupsTable from "../components/AssignedAdGroupsTable";
import AdUnitHeroCard from "../components/AdUnitHeroCard";
import { useLibraryCreativesContext } from "../../../../core/components/creatives/library/useLibraryCreativesContext";
import AdUnitAssignmentModal from "../components/AdUnitAssignmentModal";
import { useAssignAdUnits } from "../hooks/assignAdUnits";
import { useDeleteMedias } from "../hooks/useDeleteMedias";

import { fontSize, fontWeight, fontFamily, space, icon as iconSize, text } from "../../Tasks/configs/designTokens";
import { useCreativeNavigation } from "../hooks/useCreativeNavigation";

const AdUnitDetail = () => {
  // NEW: Use centralized navigation hook instead of manual navigation logic
  const { navigateBack } = useCreativeNavigation();

  // Context and state
  const {
    orgMedia,
    adGroupCreatives,
    assignedAdGroupUnit,
    refetchMedias,
  } = useLibraryCreativesContext();

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedAdGroupIds, setSelectedAdGroupIds] = useState([]);
  const { handleAssignAdUnits, assigning } = useAssignAdUnits(() =>
    setModalVisible(false)
  );

  const selectedAdUnits = orgMedia ? [orgMedia.media] : [];
  const availableAdGroups = adGroupCreatives || [];
  const { handleDeleteMedias } = useDeleteMedias();

  // NEW: Enhanced back navigation with intelligent fallback
  const handleBackNavigation = () => {
    navigateBack({
      mediaType: 'DISPLAY',
      isAdGroup: false
    });
  };

  const handleDeleteAndRedirect = async ids => {
    try {
      await handleDeleteMedias(ids);
      await refetchMedias();
      handleBackNavigation();
    } catch (error) {
      console.error('Failed to delete media:', error);
      // Error handling is already done in handleDeleteMedias hook
    }
  };

  // Get creative name for breadcrumb
  const creativeName = orgMedia && orgMedia.media ? orgMedia.media.name : "Loading...";

  return (
    <>
      <PageHeaderLayout
        title={
          <div style={{
            display: 'flex', alignItems: 'center', gap: space[2], minHeight: space[16],
            fontFamily: fontFamily.base, fontSize: fontSize.title, fontWeight: fontWeight.semibold,
            color: text.heading, letterSpacing: '-0.01em', lineHeight: 1.2, margin: 0,
          }}>
            <AppstoreAddOutlined style={{ fontSize: iconSize.lg }} />
            {creativeName}
          </div>
        }
        centerContent={
          <div style={{ display: 'flex', alignItems: 'center', minHeight: space[16] }}>
            <Button type="default" size="large" onClick={handleBackNavigation}>
              Back
            </Button>
          </div>
        }
      />

      <Row gutter={[16, 16]} className="crow-whole-page">
        <Col span={24}>
          <AdUnitHeroCard
            orgMedia={orgMedia}
            isVideo={false}
            onDelete={handleDeleteAndRedirect}
            assignedGroupCount={assignedAdGroupUnit ? assignedAdGroupUnit.length : 0}
          />
        </Col>
        <Col span={24} className="ccol-ad-groups">
          <Card
            title="ASSIGNED AD GROUPS"
            extra={
              <Button type="default" onClick={() => setModalVisible(true)}>
                Assign to Ad Groups
              </Button>
            }
            className="creative-detail-card"
          >
            <AssignedAdGroupsTable assignedAdGroupUnit={assignedAdGroupUnit} />
          </Card>
          <AdUnitAssignmentModal
            open={modalVisible}
            onCancel={() => setModalVisible(false)}
            selectedAdUnits={selectedAdUnits}
            availableAdGroups={availableAdGroups}
            selectedAdGroupIds={selectedAdGroupIds}
            setSelectedAdGroupIds={setSelectedAdGroupIds}
            onAssign={() =>
              handleAssignAdUnits(
                selectedAdGroupIds,
                selectedAdUnits.map(u => u.id)
              )
            }
            assigning={assigning}
            mediaType="IMAGE"
          />
        </Col>
      </Row>
    </>
  );
};

export default AdUnitDetail;
